export default "__VITE_ASSET__CgQlevQq__"